export function getAuthToken(): string | null {
  return (
    localStorage.getItem('authToken') || localStorage.getItem('agentToken')
  );
}

export function handleUnauthorized() {
  localStorage.removeItem('authToken');
  window.location.href = '/';
}
